uniform float time;
uniform float progress;
uniform sampler2D uMap;
uniform vec4 resolution;
varying vec2 vUv;
varying vec3 vPosition;
float PI = 3.141592653589793238;
float rand(vec2 co){
    return fract(sin(dot(co, vec2(12.9898, 78.233))) * 43758.5453);
}
void main()	{

	vec4 c = texture2D(uMap, vUv);

	vec2 toCenter = vec2(0.5) - vUv;

	vec4 original = texture2D(uMap, vUv );

	vec4 color = vec4(0.0);
	float total = 0.0;
	for(float i = 0.; i < 20.; i++) {
		float lerp = (i + rand(vec2(gl_FragCoord.x,gl_FragCoord.y )))/20.;

		float weight = sin(lerp * PI);
		vec4 mysample = texture2D(uMap, vUv + toCenter*lerp*0.5);
		mysample.rgb *=mysample.a;
		color += mysample*weight;
		total +=weight;
	}
	color.a = 1.0;
	color.rgb /= total;


	vec4 finalColor = 1. - (1. - color)*(1. - original);


	gl_FragColor = vec4(toCenter, 0.0, 1.0);
	gl_FragColor = color;
	gl_FragColor = finalColor;
	// gl_FragColor = original;
	// gl_FragColor = vec4(
	// 	vec3(rand(vUv)),
	// 	1.
	// 	);
}